<div class="container">
  <div class="page_container">
    <app-hero-section
      [vertical]="vertical"
      [heroImageUrl]="heroImgUrl"
      [isJobsPage]="isJobsPage"
      [noRelTasks]="noRelTasks"
      [q50Price]="q50Price"
      [url]="url"
      [isFindPage]="isFindPage"
      [hasAssociatedTasks]="hasAssociatedTasks"
      [hasFaqContent]="hasFaqContent"
      [hasPriceAndReview]="priceAndReviewRendered"
      [hasGoodToKnow]="hasGoodToKnow"
      (setGetQuote)="setGetQuote($event.value)"
      (openAuthDialog)="openAuthDialog()"
    ></app-hero-section>

    <div class="trustpilot-desktop-widget-container">
      <app-trustpilot-widget />
    </div>

    @if (isFindPage) {
      <app-value-line />

      @if (users && users.length > 0) {
        <!-- emitSchema off: six free-floating LocalBusiness entities with no
             @id competed with the page's Product as its primary entity -->
        <app-best-associated-users
          [vertical]="vertical"
          [reviewPriceShowing]="priceReviewShowing"
          [users]="users"
          [emitSchema]="false"
        />
      }

      @if (similarTasksForStats && similarTasksForStats.length > 0) {
        <app-mini-vertical-stats [similarTasks]="similarTasksForStats" />
      }

      <div
        class="similar-tasks-stats-container outer_seo_page_component_container"
      >
        <div
          class="similar-tasks-stats-container_inner inner_seo_page_component_container"
        >
          <h2 class="heading_2">Priser og anmeldelser</h2>
          @if (hasVertical && miniVertical) {
            <app-mini-vertical-price-review
              [miniVertical]="miniVertical"
              [priceGuideTitle]="miniVertical.aiPriceguideTitle"
              [priceGuideLink]="getPriceGuideLink()"
              [priceLow]="q25Price"
              [priceMedium]="q50Price"
              [priceHigh]="q75Price"
            />
          }
          @if (similarTasksForStats && similarTasksForStats.length > 0) {
            <app-similar-tasks
              [similarTasks]="processedSimilarTasks"
              [sectionId]="'mini-vertical-similar-tasks'"
              (imageViewerOpen)="onImageViewerOpen($event)"
              [showTitle]="false"
              [cardBackgroundWhite]="true"
            />
          }
        </div>
      </div>
      <app-how-it-works
        [left_align]="true"
        [noButton]="true"
        [isVerticalPage]="true"
        [titleLabel]="verticalH1"
      />
    }

    <app-associated-tasks
      [vertical]="vertical"
      [relTasks]="relTasks"
      [isJobsPage]="isJobsPage"
    />

    @if (isFindPage && miniVertical) {
      @if (miniVertical.mProvide) {
        <app-include-content [vertical]="vertical" />
      }
      @if (!hasWhatItIncludesArea) {
        <div class="spacer_vertical"></div>
      }
    }

    <app-why-handyhand
      [isPinployeeVerticalPage]="isJobsPage"
      [titleLabel]="verticalH1"
    />

    <div class="spacer">
      <app-faq-content
        [vertical]="vertical"
        [isFindPage]="isFindPage"
        [isJobsPage]="isJobsPage"
      />
    </div>

    @if (vertical) {
      <app-good-to-know [vertical]="vertical" [content]="goodToKnowContent" />
      @if (hasAssociatedTasks) {
        <app-why-content
          [vertical]="vertical"
          [relTasks]="relTasks"
          [q25Price]="q25Price"
          [q50Price]="q50Price"
          [q75Price]="q75Price"
        />
      }
      <app-related-services [content]="relatedServicesContent" />
    }

    <div class="link_container_holder">
      @if (relatedVertical) {
        <app-links-container
          [vertical]="relatedVertical"
          [isJobsPage]="false"
          [hideCityOrRegionLinks]="true"
          [url]="url || ''"
          [verticalPage]="true"
        />
      }
    </div>
  </div>

  <div class="breadcrumb-list outer_seo_page_component_container">
    <div class="inner_seo_page_component_container">
      <app-breadcrumb-list
        [partsOfUrl]="partsOfUrl"
        [transparent]="true"
        [vertical]="true"
      />
    </div>
  </div>
  <app-lp-footer></app-lp-footer>
  @if (schema) {
    <div [innerHTML]="schema | jsonLd"></div>
  }

  @if (showImageViewer) {
    <app-image-viewer
      [images]="selectedTaskImages"
      [startIndex]="selectedImageIndex"
      (closed)="closeImageViewer()"
    >
    </app-image-viewer>
  }
</div>
